import { ChevronUpIcon } from '@heroicons/react/20/solid';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Actions as TIMESHEETIMPORTACTIONS } from '../../store/actions/timesheetImportActions';

const DepartmentRow = ({ department, employees, selectEmployee, selectedEmployees }) => {

    const [show, setShow] = useState(true);
    const [allChecked, setAllChecked] = useState(false);

    // Map through all employees of the current department & set their redux state as selected
    const selectAllEmployees = (selected) => {
        employees && employees.filter(employee => employee.departmentName === department.name).map((employee) => {
            selectEmployee(employee.id, selected);
        });
        setAllChecked(selected);
    }

    return (
        <>
            <thead>
                <tr>
                    <th style={{ width: "60%" }}>{department.name || "No Department"}</th>
                    <th>
                        <label className="css-input css-checkbox css-checkbox-success">
                            <input
                                type="checkbox"
                                checked={allChecked}
                                onChange={(e) => selectAllEmployees(e.target.checked)}
                            />
                            <span />&nbsp;
                        </label>
                    </th>
                    <th><a className="btn btn-xs btn-default" onClick={() => setShow(!show)}><ChevronUpIcon className="h-5 w-5 text-dark-gray" style={{ marginTop: "3px" }} /></a></th>
                </tr>
            </thead>
            <tbody>
                {show && employees?.filter(employee => employee.departmentName === department.name).map((employee) => {
                    return (
                        <tr key={employee.id}>
                            <td style={{ width: "60%" }}><label htmlFor={`checkbox-${employee.id}`}>{`${employee.employeeName} ${employee.employeeSurname}`}</label></td>
                            <td>
                                <label className="css-input css-checkbox css-checkbox-success">
                                    <input
                                        type="checkbox"
                                        id={`checkbox-${employee.id}`}
                                        checked={selectedEmployees.includes(employee.id)}
                                        onChange={(e) => {
                                            // If unchecked, also uncheck the all checkbox
                                            if (!e.target.checked) setAllChecked(false);
                                            selectEmployee(employee.id, e.target.checked);
                                        }}
                                    />
                                    <span />
                                </label>
                            </td>
                            <td />
                        </tr>
                    )
                })}
            </tbody>
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        // Get selected employees by agreement ids in array
        selectedEmployees: Object.entries(state.timesheetImport.employees).filter(employee => employee[1]).map((employee) => String(employee[0]))
    }
}

const mapDispatchToProps = dispatch => ({
    selectEmployee: (employee, selected) => dispatch(TIMESHEETIMPORTACTIONS.selectEmployee(employee, selected))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DepartmentRow)